<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Sub Category Preview"
      id="admin_delete_sub_category"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Delete
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="sub_category.name"
        :icon="sub_category.icon"
        :img_src="sub_category.thumb_nail"
        :facts="view_header_facts"
        :description="sub_category.description"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Delete Sub Category Form"
      id="admin_delete_sub_category_form"
    ></CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="sub_categories_delete_form_ref"
      id="sub_categories_delete_form"
      message="<b>Delete was succesfull</b> <br/> The Sub Category has been removed"
      :is_loading="is_loading"
      :seed="{sub_category:[$route.params.id]}"
      @on-delete-success="on_success"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import ViewHeader from "../../../components/ViewHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import DeleteConcentForm from "../../../components/DeleteConcentForm";

import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminSubCategoriesDelete",
  components: {
    CardedSectionHeader,
    ViewHeader,
    CardedDisplay,
    DeleteConcentForm,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      sub_category: {
        id: 0,
        name: "",
        category: null,
        thumb_nail: "",
        description: "",
      },
      errors: [],
      message: "",
    };
  },
  methods: {
    load_sub_category() {
      this.$emit("on-show-loader");
      ServerClient.Categories.get_sub_category(
        {
          id: this.$route.params.id,
          is_edit: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.sub_category = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading sub category details on admin delete",
            errors
          );
        }
      );
    },
    on_success() {
      //go back to categories list
      this.$router.push("/admin/categories/sub_categories/list");
    },
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "Category:",
          val: this.sub_category.category
            ? this.sub_category.category.name
            : "",
        },
        {
          text: "Top Category:",
          val:
            this.sub_category.category &&
            parseInt(this.sub_category.category.is_top_category) == 1
              ? "Yes"
              : "No",
        },
        {
          text: "Top Category Level:",
          val: this.sub_category.category
            ? this.sub_category.category.top_category_level
            : 0,
        },
      ];
      return facts;
    },
  },

  mounted() {
    var sub_category_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin Delete Sub Category",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Categories",
          disabled: false,
          href: "/admin/categories",
        },
        {
          text: "Subs",
          disabled: false,
          href: "/admin/categories/sub_categories/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/categories/sub_categories/view/" + sub_category_id,
        },
        {
          text: "Delete",
          disabled: true,
          href:
            "/admin/categories/sub_categories/view/" +
            sub_category_id +
            "/delete",
        },
      ],
      navbar_cols: 3,
    });
    this.load_sub_category();
  },
};
</script>